<template>
  <base-section id="descubre">
    <base-section-heading title="Diseñado para ser Efectivo">
      Hemos cuidado todos los aspectos de nuestra herramienta de limpieza para sacar el máximo rendimiento con el menor consumo posible de agua y tiempo.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis illum veniam cum dolores ratione commodi beatae quas maxime, laboriosam excepturi solut!
          </base-avatar-card>

          <base-img
            class="px-5 mx-5"
            v-bind="feature"
            max-width="450"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionDescubre',

    data: () => ({
      features: [
        {
          title: 'Difusor',
          text: 'Paint Clean Box ha sido cuidadosamente diseñado para una limpieza a fondo de los rodillos de pintura al agua. Cuenta con un difusor que optimiza la presión del agua, tomada de cualquier grifo de la vivienda o nave industrial, transformándola en una cortina de agua a presión eficiente que induce al rodillo la energía centrífuga necesaria para arrancar, desde su núcleo hacia afuera, la pintura impregnada en el mismo. No necesita electricidad ni ningún otro mecanismo para su funcionamiento.',
          src: require('@/assets/difusor.jpg'),
        },
        {
          title: 'Tapa',
          text: 'Paint Clean Box cuenta además con una tapa abisagrada, destinada a evitar las salpicaduras durante el proceso de limpieza que, a su vez, está provista de una aleta diseñada hidrodinámicamente para la limpieza tanto de la parte superior como interior del rodillo, extrayendo los restos de pintura que pudieran alojarse en el mismo.',
          src: require('@/assets/tapa.jpg'),
        },
      ],
    }),

    computed: {
      media () {
        return this.$vuetify.breakpoint
      },

      dimensionVideo () {
        const w = 560
        const h = 315
        const result = {
          w: this.media.width < w ? this.media.width - 20 : w,
          h: this.media.width < w ? h * (this.media.width - 20) / w : h,
        }
        return result
      },
    },
  }
</script>
